export const EMAIL_REGEX = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
export const PHONE_REGEX = /^\+[1-9]\d{1,14}$/;

export const REQUIRED = (t: (key: string) => string) => ({
  required: t("required"),
});
